var paramsSetUrl = function (baseUrl, params) {
    var urlParams = new URLSearchParams({});
    params.forEach(function (_a) {
        var key = _a.key, value = _a.value;
        if (!key || !value) {
            return;
        }
        urlParams.set(key, value);
    });
    return String(urlParams) ? baseUrl + "?" + String(urlParams) : baseUrl;
};
export default paramsSetUrl;
